<div class="ig-calendar modern-block">
  <ig-water-fall-container *ngIf="isCalendarStyleLoaded" #waterFallContainer [hidden]="isNoContent"
    [itemWidth]="calendarCardWidth" [maxColumnCount]="maxColumn" [isAllItemsLoaded]="isAllDataLoaded"
    [class.ig-places]="!actionCommand?.isEventCalendar"
    [modernBlockStyle]="actionCommand?.isEventCalendar&&frontendSettings.customSettings?.calendarStyle?.event==='modern-block'"
    [isRandom2TimesWidthCard]="!isMobile
            && !actionCommand?.isEventCalendar
            && frontendSettings.customSettings.calendarStyle.place === 'tile'" (onLoadMore)="loadMore()">
    <ng-container *ngIf="actionCommand?.isEventCalendar">
      <ng-container *ngIf="isContentLoaded">
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.event === 'default'">
          <ig-visitor-event-card *ngFor="let event of events" [event]="event"></ig-visitor-event-card>
        </ng-container>
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.event === 'square'">
          <ig-visitor-square-card *ngFor="let event of events" [item]="event"></ig-visitor-square-card>
        </ng-container>
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.event === 'long'">
          <ig-visitor-long-card *ngFor="let event of events" [item]="event"></ig-visitor-long-card>
        </ng-container>
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.event === 'modern-block'">
          <ig-visitor-modern-block class="modern-block-item" *ngFor="let event of events"
            [item]="event"></ig-visitor-modern-block>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!actionCommand?.isEventCalendar">
      <ng-container *ngIf="isContentLoaded">
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.place === 'default'">
          <ig-visitor-place-card *ngFor="let place of places" [place]="place"></ig-visitor-place-card>
        </ng-container>
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.place === 'square'">
          <ig-visitor-square-card *ngFor="let place of places" [item]="place"></ig-visitor-square-card>
        </ng-container>
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.place === 'long'">
          <ig-visitor-long-card *ngFor="let place of places" [item]="place"></ig-visitor-long-card>
        </ng-container>
        <ng-container *ngIf="frontendSettings.customSettings.calendarStyle.place === 'tile'">
          <ig-visitor-larger-card *ngFor="let place of places" [item]="place"></ig-visitor-larger-card>
        </ng-container>
      </ng-container>
    </ng-container>

    <div id="event-calendar-footer">
      <div *ngIf="isAllDataLoaded &&isMobile" class="no-more-data">
        {{
        actionCommand?.isEventCalendar ? "No More Events" : "No More Places"
        }}
      </div>
    </div>
  </ig-water-fall-container>

  <ng-container>
    <ig-page-spinner #spinner></ig-page-spinner>
  </ng-container>

  <ig-no-content *ngIf="isNoContent"></ig-no-content>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/calendar/visitor.calendar.component.html